import { Link } from 'react-router-dom'
import { ABOUT_CONTENT, IMAGES } from '../data/content'

function AboutPage() {
    return (
        <div className="pt-28 bg-gradient-to-b from-white via-brand-blue-light/10 to-brand-blue-light/30 overflow-x-hidden">
            {/* About Hero Section */}
            <section className="relative min-h-[50vh] px-4 pb-12">
                {/* Background cloud blobs */}
                <svg
                    className="absolute -top-20 -right-32 w-[700px] h-[500px] text-brand-blue-light opacity-30 -z-10"
                    viewBox="0 0 200 150"
                    fill="currentColor"
                >
                    <ellipse cx="100" cy="80" rx="90" ry="60" />
                    <ellipse cx="60" cy="90" rx="50" ry="40" />
                    <ellipse cx="140" cy="85" rx="55" ry="45" />
                </svg>

                {/* Decorative Elements */}
                <div className="absolute right-32 top-20 hidden lg:block">
                    <div className="w-16 h-16 rounded-full border-2 border-brand-blue"></div>
                </div>
                <div className="absolute right-24 top-32 hidden lg:block">
                    <div className="w-4 h-4 rounded-full bg-brand-blue"></div>
                </div>
                <div className="absolute left-20 top-1/3 hidden lg:block">
                    <div className="w-3 h-3 rounded-full bg-brand-blue opacity-60"></div>
                </div>

                {/* Plus sign - left */}
                <div className="absolute left-14 bottom-1/4 hidden lg:block">
                    <svg className="w-8 h-8 text-brand-blue opacity-50" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                </div>


                {/* Curved line - right side */}
                <svg
                    className="absolute right-0 top-1/2 w-[200px] h-[400px] text-brand-blue opacity-30 hidden lg:block"
                    viewBox="0 0 100 200"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path d="M100 0 Q 0 100, 100 200" />
                </svg>

                <div className="max-w-[1500px] mx-auto grid lg:grid-cols-2 gap-16 items-center px-6">
                    {/* Text Content - Left Side */}
                    <div className="text-center lg:text-left">
                        <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-brand-blue mb-8">
                            <span className="border-b-4 border-brand-blue pb-2">ABOUT</span>
                        </h1>
                        <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-xl">
                            {ABOUT_CONTENT.description}
                        </p>
                    </div>

                    {/* Polaroid Photos - Right Side */}
                    <div className="relative h-[500px] hidden lg:block">
                        <div className="absolute left-0 top-10 transform -rotate-6 bg-white p-3 shadow-xl rounded-sm">
                            <div className="w-64 h-72 bg-gray-200 overflow-hidden">
                                <img src="/images/ClubPhoto4.png" alt="CS Foreach team event" className="w-full h-full object-cover" />
                            </div>
                            <div className="h-8"></div>
                        </div>
                        <div className="absolute right-0 top-24 transform rotate-6 bg-white p-3 shadow-xl rounded-sm z-10">
                            <div className="w-72 h-64 bg-gray-200 overflow-hidden">
                                <img src="/images/ClubPhoto3.png" alt="CS Foreach team" className="w-full h-full object-cover" />
                            </div>
                            <div className="h-8"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Mission Section */}
            <section className="relative py-12 px-4">
                <div className="max-w-[1500px] mx-auto px-6 text-center">
                    <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-blue mb-12">OUR MISSION</h2>
                    <div className="bg-white p-12 rounded-[2rem] shadow-xl border border-gray-50 max-w-4xl mx-auto relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-brand-blue-light opacity-10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                        <p className="text-xl text-gray-700 leading-relaxed italic">
                            "Striving to make access to CS opportunities and resources more equitable for each and every student."
                        </p>
                    </div>
                </div>
            </section>

            {/* Navigation CTA Section */}
            <section className="relative py-24 px-4 overflow-hidden bg-white/50 backdrop-blur-sm">
                <div className="max-w-[1500px] mx-auto px-6">
                    <div className="grid md:grid-cols-2 gap-12">
                        {/* Link to Team */}
                        <div className="flex flex-col items-center text-center p-12 bg-white rounded-3xl shadow-lg border border-gray-100 hover:shadow-2xl transition-all group">
                            <div className="w-20 h-20 bg-brand-blue-light/20 rounded-2xl flex items-center justify-center text-brand-blue mb-8 group-hover:rotate-6 transition-transform">
                                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
                            </div>
                            <h3 className="text-3xl font-heading font-bold text-brand-blue mb-4">MEET OUR TEAM</h3>
                            <p className="text-gray-600 mb-8 leading-relaxed">
                                Get to know the passionate students and mentors behind CS Foreach.
                            </p>
                            <Link to="/team" className="btn btn-primary-solid rounded-xl px-12">VIEW TEAM</Link>
                        </div>

                        {/* Link to Get Involved */}
                        <div className="flex flex-col items-center text-center p-12 bg-white rounded-3xl shadow-lg border border-gray-100 hover:shadow-2xl transition-all group">
                            <div className="w-20 h-20 bg-brand-blue-light/20 rounded-2xl flex items-center justify-center text-brand-blue mb-8 group-hover:-rotate-6 transition-transform">
                                <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
                            </div>
                            <h3 className="text-3xl font-heading font-bold text-brand-blue mb-4">GET INVOLVED</h3>
                            <p className="text-gray-600 mb-8 leading-relaxed">
                                Find out how you can contribute to our mission as a student, educator, or partner.
                            </p>
                            <Link to="/get-involved" className="btn btn-primary-solid rounded-xl px-12">JOIN US</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutPage
